import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import {
  Clock,
  MapPin,
  Building2,
  MessageSquare,
  CheckCircle,
  XCircle,
} from 'lucide-react';
// @ts-ignore - TODO: Fix this TypeScript error
import type { ServiceRequest } from '@/lib/types';

interface ServiceRequestDetailsProps {
  request: ServiceRequest;
  onEdit: () => void;
}

export function ServiceRequestDetails({ request, onEdit }: ServiceRequestDetailsProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>{request.title}</CardTitle>
          <div className="flex items-center gap-2 mt-2">
            <Badge
              variant={
                request.status === 'completed' ? 'default' :
                request.status === 'in_progress' ? 'secondary' :
                request.status === 'cancelled' ? 'destructive' :
                'outline'
              }
            >
              {request.status.replace('_', ' ')}
            </Badge>
            <Badge
              variant={
                request.priority === 'high' ? 'destructive' :
                request.priority === 'medium' ? 'secondary' :
                'outline'
              }
            >
              {request.priority} priority
            </Badge>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onEdit}>
            Edit Request
          </Button>
          {request.status === 'pending' && (
            <>
              <Button variant="default">
                <CheckCircle className="mr-2 h-4 w-4" />
                Approve
              </Button>
              <Button variant="destructive">
                <XCircle className="mr-2 h-4 w-4" />
                Cancel
              </Button>
            </>
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">Description</h3>
            <p className="mt-1">{request.description}</p>
          </div>

          <div className="grid gap-4 md:grid-cols-3">
            <div>
              <h3 className="text-sm font-medium text-muted-foreground">Property</h3>
              <div className="flex items-center gap-2 mt-1">
                <Building2 className="h-4 w-4 text-muted-foreground" />
                <span>{request.property.name}</span>
              </div>
            </div>
            <div>
              <h3 className="text-sm font-medium text-muted-foreground">Location</h3>
              <div className="flex items-center gap-2 mt-1">
                <MapPin className="h-4 w-4 text-muted-foreground" />
                <span>Building A, Floor 2</span>
              </div>
            </div>
            <div>
              <h3 className="text-sm font-medium text-muted-foreground">Created</h3>
              <div className="flex items-center gap-2 mt-1">
                <Clock className="h-4 w-4 text-muted-foreground" />
                <span>{new Date(request.createdAt).toLocaleString()}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t pt-6">
          <div className="flex items-center gap-2 mb-4">
            <MessageSquare className="h-4 w-4 text-muted-foreground" />
            <h3 className="font-medium">Activity Log</h3>
          </div>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-primary/10">
                <CheckCircle className="h-4 w-4 text-primary" />
              </div>
              <div>
                <p className="text-sm">Request created</p>
                <p className="text-xs text-muted-foreground">
                  {new Date(request.createdAt).toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}